import { useState } from 'react'
import { AudioEngine } from './engine.js'
import { useAsyncUserConfigService } from '@tunasong/ui-lib'

export const useCreateAudioEngine = (enabled = true) => {
  const configService = useAsyncUserConfigService()
  /**
   * Lazy initializer form. The non-lazy form `useState(new AudioEngine(...))`
   * evaluates the expression on every render — useState discards subsequent
   * values, but the constructor still runs. AudioEngine's constructor calls
   * `oldContext.dispose()` on the global Tone.js context, which crashes every
   * live AudioNode bound to it (notably the GlobalAudioPlayer's
   * MediaElementSource). HMR-induced parent re-renders triggered the "Dead
   * Tuna" error boundary as a result.
   *
   * The `typeof window` check stays inside the initializer so SSR still skips
   * construction entirely.
   */
  const [engine] = useState(() => (typeof window !== 'undefined' ? new AudioEngine({ configService }) : null))

  return enabled ? engine : null
}
